import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useAuth } from "react-oidc-context";
import { Sidebar } from "../../components/Sidebar";
import { PageHeader, LoadingState, ErrorState } from "../../components/UI";
import SimpleRewardFormV2 from "../../components/GreenMiles/CreateReward/SimpleRewardForm";

const API_URL = process.env.REACT_APP_API_URL || "/api";

function EditRewardPage() {
  const { hotelId, rewardId } = useParams();
  const navigate = useNavigate();
  const auth = useAuth();
  const token = auth.user?.access_token;

  const [rewardInfo, setRewardInfo] = useState(null);
  const [hotelInfo, setHotelInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hotelId && rewardId && token) {
      fetchData();
    }
  }, [hotelId, rewardId, token]);

  const fetchData = async () => {
    try {
      setLoading(true);
      setError(null);

      const [hotelResponse, rewardResponse] = await Promise.all([
        fetch(`${API_URL}/greenmiles/hotels/${hotelId}`, {
          headers: { Authorization: `Bearer ${token}` },
        }),
        fetch(`${API_URL}/greenmiles/hotels/${hotelId}/rewards/${rewardId}`, {
          headers: { Authorization: `Bearer ${token}` },
        }),
      ]);

      const hotelData = await hotelResponse.json();
      const rewardData = await rewardResponse.json();

      if (hotelData.success === "OK") {
        setHotelInfo(hotelData.result.hotel);
      }

      if (rewardData.success === "OK") {
        setRewardInfo(rewardData.result);
      } else {
        setError(rewardData.message || "Récompense non trouvée");
      }
    } catch (err) {
      console.error("Erreur lors du chargement:", err);
      setError("Erreur lors du chargement des données");
    } finally {
      setLoading(false);
    }
  };

  const handleSuccess = () => {
    navigate(`/hotels/${hotelId}/greenmiles/rewards`, {
      state: {
        message: "Récompense modifiée avec succès !",
        type: "success",
      },
    });
  };

  const handleCancel = () => {
    navigate(`/hotels/${hotelId}/greenmiles/rewards`);
  };

  if (loading) {
    return <LoadingState message="Chargement des données de la récompense..." />;
  }

  if (error) {
    return <ErrorState error={error} />;
  }

  if (!rewardInfo) {
    return <ErrorState error="Récompense non trouvée" />;
  }

  return (
    <div className="flex h-screen bg-gray-50">
      <Sidebar />
      <div className="flex-1 overflow-auto">
        <PageHeader title={`Modifier la récompense - ${hotelInfo?.hName || hotelId}`} onGoBack={handleCancel} />
        <div className="p-6">
          <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-sm p-6">
            <SimpleRewardFormV2 hotelId={hotelId} rewardType={rewardInfo.rwType} rewardId={rewardId} onSuccess={handleSuccess} onCancel={handleCancel} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default EditRewardPage;
